"use client"

export default function NotFound() {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 px-4 py-12"
      style={{ fontFamily: "ui-sans-serif, system-ui, sans-serif" }}
    >
      <div className="flex w-full max-w-lg flex-col items-center rounded-2xl bg-white p-10 shadow-2xl md:p-16">
        <div className="flex flex-col items-center">
          <span className="mb-4 select-none text-7xl font-extrabold text-rose-500 drop-shadow-sm">
            404
          </span>
          <p className="mb-8 gap-4 text-center text-lg text-muted-foreground">
            These are not the bytes you are looking for...
          </p>
        </div>
        <div className="mt-4 flex w-full flex-col justify-center gap-4 md:flex-row">
          <a
            href="/"
            className="w-full rounded-xl border border-gray-200 bg-gray-100 px-6 py-3 text-center text-lg font-medium text-gray-700 shadow transition hover:bg-gray-200"
          >
            Go Home
          </a>
        </div>
      </div>
    </div>
  )
}
